module.exports = __webpack_public_path__ + "static/img/service-ac-jogjakarta-1.e7b8195.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kegiatan/service-ac-jogjakarta-1.jpg
// module id = Kkg+
// module chunks = 0